import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  maxHeight: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: "scroll",
};

const ErrorModal = props => {

  const handleClose = () => {
    props.setApiRes({
      ...props.apiRes, 
      axiosError: false,
    });
  };

  return (
    <div>
      <Modal
        open={props.apiRes.axiosError}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {props.apiRes.errHeading}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {props.apiRes.errMsg}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default ErrorModal;